import React from "react";
import "./ContactPage.css";
import ContactInfo from "../ContactInfo/ContactInfo";
import ContactForm from "../ContactForm/ContactForm";

const ContactPage = () => {
  return (
    <div className="contact-page">
      <h1 className="contact-title">Bize Ulaşın</h1>
      <p className="contact-description">
        Destek ve sorunlarınız için bizimle iletişime geçebilirsiniz.
      </p>
      <ContactInfo />
      <hr />
      <div className="contact-content">
        <div className="location-card">
          <iframe
            title="İTÜ Arı Teknokent"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3006.228085382763!2d29.029663511506236!3d41.107709513177085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab56e894d24fb%3A0xb875349b5446d05d!2zxLBUw5wgQVJJIFRla25va2VudA!5e0!3m2!1str!2str!4v1753960361520!5m2!1str!2str"
            width="100%"
            height="240"
            style={{ border: 0, borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
          <p className="location-name">Lingify.co</p>
          <p className="location-description">İTÜ Arıteknokent 3 Binası, Maslak / İstanbul</p>
        </div>

        <ContactForm />
      </div>
    </div>
  );
};

export default ContactPage;
